import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintKekuranganUangMuka2 = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocKekuranganUangMuka2 = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          SURAT PENGAKUAN KEKURANGAN BAYAR UANG MUKA
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginBottom: "10px" }}>Saya yang bertanda tangan di bawah ini:</div>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
            <tbody style={{ border: "1px solid black" }}>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Tempat, Tanggal Lahir</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? ""}
                </td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Pekerjaan</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>No. KTP</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "10px" }}>Dengan ini menyatakan bahwa saya telah melakukan pembayaran uang muka sebesar Rp.......................................................... (..............................................................) dan masih memiliki kekurangan bayar Uang Muka sebesar ..........................................................) untuk pembelian Rumah Sejahtera Tapak kepada:</div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
            <tbody style={{ border: "1px solid black" }}>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Tempat, Tanggal Lahir</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>
                  {item.sls_appl?.birth_place_spouse ?? ""} , {handleValidDate(item.sls_appl?.birthat_spouse) ?? ""}
                </td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Pekerjaan</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>No. KTP</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <p style={{ marginTop: "20px" }}>Jika permohonan SBUM saya tidak disetujui, maka saya bersedia untuk membayar kekurangan uang muka pembelian rumah sejahtera tapak menggunakan dana sendiri.</p>
          <p>Demikian kami sampaikan, atas perhatiannya kami ucapkan terima kasih.</p>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "80%",
              border: "1px solid black",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    width: "50%",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Menyetujui,
                  <br />
                  (DIREKTUR UTAMA)
                  <br />
                  <br />
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    textAlign: "center",
                  }}
                >
                  ......................, tanggal ................ 20...
                  <br />
                  <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                  <br /> <span style={{ fontWeight: "bold" }}>PEMOHON</span> <br /> <br />
                </td>
              </tr>

              {/* Kotak Materai */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "38px 12px 8px 12px",
                    verticalAlign: "top",
                  }}
                >
                  {/* Kosong untuk tanda tangan kiri */}
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    verticalAlign: "middle",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid black",
                      width: "140px",
                      height: "80px",
                      top: "-20px",
                      left: "50%",
                      padding: "10px",
                      fontSize: "12px",
                      textAlign: "center",
                      position: "absolute",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                    }}
                  >
                    Meterai
                    <br />
                    Rp. 10.000,-
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  Ttd dan Cap Perusahaan <br />
                  ( ..................................................... )
                  <br />
                  <span style={{ fontWeight: "bold" }}>ANGGA BUDI KUSUMA</span>
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  {item.sls_appl?.name ?? "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
